<template>
    <div class="main-content">
        <PageHeader>
            <PageHeaderTitleContent>
                <TitleTextContent
                    :titleText="'Informational Videos'"
                    :subTitleText="'Project Spectrum\'s informational videos provide a brief overview of key cybersecurity topics, allowing viewers to gain valuable knowledge in under 10 minutes per video.<br><br>Use this page as a valuable resource to learn all things about cyber security and awareness.'"
                />
            </PageHeaderTitleContent>
        </PageHeader>

        <div class="container-fluid px-xs-1 px-md-5 px-lg-5 px-xl-5">
            <section class="mt-5" id="videos-display-section">
                <div class="container-fluid px-3 px-md-0 px-lg-0 px-xl-0">
                    <v-row>
                        <v-col cols="12">
                            <div class="d-flex flex-column justify-content-start w-100">
                                <div class="d-flex flex-row justify-content-center section-title w-100">
                                    <span>WATCH VIDEOS</span>
                                </div>

                                <SearchControlWidget
                                    :inputTextPlaceholder="'Enter video title here'"
                                    :searchControlHeight="'100px'"
                                    :searchQueryInputHandler="updateSearchQuery"
                                />
                            </div>
                        </v-col>
                    </v-row>
                </div>
            </section>

            <section class="my-4">
                <VideoListItems
                    :videoInfoList="videoInfoList"
                    :videoSearchQuery="videoSearchQuery"
                    :scrollToElementId="'videos-display-section'"
                    :searchByVideoType="true"
                />
            </section>
        </div>
    </div>
</template>

<script>
    import VideoListItems from "./library/widgets/video-list-items.vue";
    import PageHeader from "./library/widgets/page-header.vue";
    import PageHeaderTitleContent from "./library/widgets/page-header-title-content.vue";
    import TitleTextContent from "./library/widgets/title-text-content.vue";
    import SearchControlWidget from './library/widgets/search-control-widget.vue';
    import informtionalVideos from "../utils/informationalVideosData";
    export default {
        components: {
            VideoListItems,
            PageHeader,
            PageHeaderTitleContent,
            TitleTextContent,
            SearchControlWidget,
        },
        data(){
            return {
                videoSearchQuery: "",
                videoInfoList: informtionalVideos.toSorted((a, b) => a.title.localeCompare(b.title)),
            };
        },
        methods: {
            updateSearchQuery(searchText) {
                this.videoSearchQuery = searchText;
            },
        }
    }
</script>

<style scoped>
    .watch-videos-filter-query {
        width: 100%;
        min-width: 315px;
        min-height: 248px;
        border-radius: 10px;
        background-color: #D5D7D7;
        margin-top: 40px;
        padding: 20px;
    }
    .watch-videos-filter-query-text-input {
        width: 80%;
        min-width: 290px;
        height: auto;
    }
    .search-query-input-text {
        background-color: #ffffff;
        width: 100%;
        height: 50px;
        border-radius: 10px;
        padding-left: 5px;
        border: 1px solid #000000;
    }
    .search-icon-position {
        background-color: #ffffff; 
        position: absolute; 
        top: 2px; 
        right: 0;
        width: 30px; 
        height: 90%; 
        border-top-right-radius: 10px; 
        border-bottom-right-radius: 10px; 
        display: flex; 
        justify-content: center; 
        align-items: center;
    }
</style>